import AxiosAPI from "./AxiosAPI";

import axios from "axios";
export const fetchTransactionSalesApi = async (
    from = 1,
    size = 10,
    productId,
    transactionTypeId,
    transactionNo,
) => {
    try {
        let apiUrl = '/transaction/sales/product';// let apiUrl = '/transaction/sales/product';
        let queryParams = [`from=${from}`, `size=${size}`, 'isDeleted=false'];
        if (productId) {
            queryParams.push(`productId=${productId}`);
        }
        if (transactionTypeId) {
            queryParams.push(`transactionTypeId=${transactionTypeId}`);
        }
        if (transactionNo) {
            queryParams.push(`transactionNo=${transactionNo}`);
        }
        apiUrl += `?${queryParams.join("&")}`;

        console.log("Fetching URL:", apiUrl);
        const response = await AxiosAPI.get(apiUrl);
        return response.data;
    } catch (error) {
        console.error("Error fetching  data:", error);
        throw error.response?.data || error;
    }
};

export const fetchTransactionInventoryApi = async (
    from = 0,
    size = 10,
    productId,
    transactionTypeId,
    transactionNo,
) => {
    try {
        let apiUrl = '/transaction/inventory/product';
        let queryParams = [`from=${from}`, `size=${size}`];
        if (transactionTypeId) {
            queryParams.push(`transactionTypeId=${transactionTypeId}`);
        }
        if (transactionNo) {
            queryParams.push(`transactionNo=${transactionNo}`);
        }
        if (productId) {
            queryParams.push(`productId=${productId}`);
        }

        apiUrl += `?${queryParams.join("&")}`;

        console.log("Fetching URL:", apiUrl);
        const response = await AxiosAPI.get(apiUrl);
        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error.response?.data || error;
    }
};

export const fetchInstockProductApi = async (productId) => {
    try {
        const response = await AxiosAPI.get(`/inventory/instock/product?productId=${productId}`);
        return response.data;
    } catch (err) {
        console.error("Error in fetchInstockProductApi:", err);
        throw err;
    }
};

export const fetchInstockDetailSingleProduct = async (productId, locationId,from=1,size=100) => {
    try {
        // Ensure both productId and locationId are included in the query string
        // const response = await AxiosAPI.get(`/catalog/products/audittrail?key=${key}`)
          const response = await AxiosAPI.get(`/inventory/instock/item-ledger?productID=${productId}&locationID=${locationId}&from=${from}&size=${size}`);
        // const response = await axios.get(`${BASE_URL}/inventory/instock/item-ledger?productID=${productId}&locationID=${locationId}&from=${from}&size=${size}`);
        //const response = await AxiosAPI.get(`/inventory/instock/ledger?productID=${productId}&locationID=${locationId}`);
        return response.data;
    } catch (err) {
        console.error("Error in fetchInstockDetailSingleProduct:", err);
        throw err;  // Rethrow the error for further handling (e.g., in the calling function)
    }
};


export const fetchApiLogsApi = async (productId) => {
    try {
        const response = await AxiosAPI.get(`/catalog/products/apilogs?productID=${productId}`);
        return response.data;
    } catch (err) {
        console.error("Error in fetchApiLogsApi:", err);
        throw err;
    }
};

export const fetchAuditTrailApi = async (key) => {
    try {
        //const response = await AxiosAPI.get(`/catalog/products/audittrail?key=${key}`);
        const BASE_URL = "https://backend-o3dyulj4pa-el.a.run.app/v2";
        const response = await axios.get(`${BASE_URL}/catalog/products/audit-trail?key=${key}`)
        return response.data;
    } catch (err) {
        console.error("Error in fetchAuditTrailApi:", err);
        throw err;
    }
};



